import React from 'react';

import {Alert, Skeleton, Typography, TypographyProps} from '@mui/material';

interface IProps {
    loading: boolean,
    error?: boolean | string,
}

interface IState {
}

export default class Loader extends React.Component<IProps, IState> {

    private variants = ['h1', 'h3', 'body1', 'caption'] as TypographyProps['variant'][];

    async componentDidMount() {
    }

    private static getRandomInt(max: number) {
        return Math.floor(Math.random() * Math.floor(max));
    }

    render() {
        const {error, loading, children} = this.props;
        if (error) {
            return <Alert severity={"error"}>{typeof error === "string" ? error : "Error occurred"}</Alert>
        } else if (loading) {
            return <>
                <Skeleton/>
                {Array.from(Array(8).keys()).map((it) =>
                    <Typography key={it} component="div" variant={this.variants[Loader.getRandomInt(4)]}>
                        <Skeleton/>
                    </Typography>
                )}
            </>
        } else {
            return children;
        }
    }
}